import React, { useEffect, useState } from "react";

import TabelaV2 from "../../../../componentsv2/Tabela";
import Box from "../../../../componentsv2/Box";

import OpcoesTabela from "../OpcoesTabela";
import { api } from "../../../../services/Api";

export default function TabelaClientes({ busca = "" }) {
  const columns = [
    {
      field: "nome",
      headerName: "Nome",
      headerAlign: "left",
      align: "left",
      flex: 1,
      minWidth: 260,
    },
    {
      field: "cpf",
      headerName: "CPF",
      headerAlign: "center",
      align: "center",
      width: 200,
    },
    {
      field: "opcoes",
      headerName: "Opções",
      headerAlign: "center",
      align: "center",
      width: 110,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: params => <OpcoesTabela atualizarTabela={atualizarTabela} row={params.row} />,
    },
  ];

  const [rows, setRows] = useState([]);
  const [atualizaTabela, setAtualizaTabela] = useState(false);

  const atualizarTabela = () => {
    setAtualizaTabela(!atualizaTabela);
  };

  const getClientes = async () => {
    try {
      const {
        data: { data },
      } = await api.get("v2/controleDna/clientes");
      setRows(data);
    } catch (error) {}
  };

  useEffect(() => {
    getClientes();
  }, [atualizaTabela]);

  const rowsFiltradas = rows.filter(row => {
    const termo = busca.trim().toLowerCase();
    if (!termo) {
      return true;
    }

    const nome = row?.nome?.toLowerCase() || "";
    const cpf = row?.cpf?.toLowerCase() || "";
    return nome.includes(termo) || cpf.includes(termo);
  });

  return (
    <Box sx={{ height: "600px", width: "100%" }}>
      <TabelaV2 ocultarToolbar columns={columns} rows={rowsFiltradas} autoPageSize />
    </Box>
  );
}
